<template>
<div class="page-root with-footer" id="caseSearch-pageRoot">
  <div class="horizontal-scroll" id="caseSearch-horizontal-scroll">

    <div class="jumbotron" id="caseSearch-jumbotron">
      <div class="container-fluid almost-fluid" id="caseSearch-container">
        <search-filter-bar v-model="searchFilters"
                          :relation="filters.relation"
                          :batch="filters.batch"
                          :productLineName="filters.productLineName"
                          :status="filters.status"
                          :loaded="loaded"
                          @filter="handleFilter"
                          id="caseSearch-searchFilters-bar"
        ></search-filter-bar>
      </div>
    </div>

    <div class="text-center absolute-loader" v-if="!loaded" id="caseSearch-loader">
      <custom-spinner id="caseSearch-spinner"></custom-spinner>
    </div>

    <transition name="fade" mode="out-in">
      <search-table v-if="loaded" :caseList="caseList" :insurers="insurers" :productLines="productLines"></search-table>
    </transition>

  </div>

  <pagination v-model="currentPage"
              :currentPage="currentPage"
              :pageSize="pageSize"
              :pageCount="pageCount"
              :itemCount="caseCount"
  ></pagination>

</div>
</template>

<script>
import RestService from '@/service/RestService.js';
import SearchFilterBar from '@/components/cases/SearchFilterBar';
import SearchTable from '@/components/cases/SearchTable';
import Pagination from '@/components/Pagination';
import CustomSpinner from '../CustomSpinner.vue';
import GeneralConfigService from '../../service/GeneralConfigService';

export default {
  components: { SearchFilterBar, SearchTable, Pagination, CustomSpinner },
  props: {
    page: { default: 1 },
    size: { default: 10 },
    batch: { default: '' },
    relation: { default: '' },
    productLineName: { default: '' },
    status: { default: '' }
  },
  data() {
    return {
      rest: this.initRestService(),
      caseList: [],
      caseCount: null,
      pageCount: null,
      currentPage: this.page,
      pageSize: this.size,
      searchFilters: {},
      filters: {
        batch: this.batch,
        relation: this.relation,
        productLineName: this.productLineName,
        status: this.status
      },
      loaded: false,
      insurers: [],
      productLines: []
    }
  },
  beforeMount() {
    this.loadCases();
  },
  async created() {
    await this.getAllInsurers();
    await this.getProductlines();
  },
  methods: {
    initRestService() {
      return new RestService();
    },
    async loadCases() {
      this.loaded = false;
      let filterObj = {};
      if (this.filters.relation.length > 0) {
        filterObj.relation = this.filters.relation;
      }
      if (this.filters.batch.length > 0) {
        filterObj.batchid = (typeof this.filters.batch === 'string')
          ? this.filters.batch.split(',') : this.filters.batch;
      }
      if (this.filters.productLineName.length > 0) {
        filterObj.productLineName = (typeof this.filters.productLineName === 'string')
          ? this.filters.productLineName.split(',') : this.filters.productLineName;
      }
      if (this.filters.status.length > 0) {
        filterObj.status = (typeof this.filters.status === 'string')
          ? this.filters.status.split(',') : this.filters.status;
      }
      let response = await this.rest.getCaseList(this.currentPage, this.pageSize, filterObj);
      this.caseList = response.data.data;
      this.caseCount = response.data.meta.totalItems;
      this.pageCount = response.data.meta.totalPages;
      this.loaded = true;
    },
    buildUrl() {
      let queryString = '';
      queryString += '?page=' + this.currentPage;
      if (this.pageSize !== this.$options.props.size.default) {
        queryString += '&size=' + this.pageSize;
      }
      for (let key in this.filters) {
        let val = this.filters[key];
        if (typeof val !== 'undefined' && val.length > 0) {
          queryString += '&' + key + '=' + val;
        }
      }
      return queryString;
    },
    handleFilter() {
      this.filters = this.searchFilters;
      this.loadCases();
      this.updateUrl();
    },
    updateUrl() {
      this.$router.push('/cases' + this.buildUrl());
      this.$forceUpdate();
    },
    async getAllInsurers() {
      try {
        let response = await GeneralConfigService.getAllInsurerRows();
        this.insurers = response;
      } catch (error) {
        this.loadError = 'ERROR_LOADING_INSURERS';
        this.$log.error(error.response.data);
      }
    },
    async getProductlines() {
      try {
        let response = await GeneralConfigService.getAllProductLines();
        this.productLines = response;
      } catch (error) {
        this.loadError = 'ERROR_LOADING_INSURERS';
        this.$log.error(error.response.data);
      }
    }
  },
  watch: {
    currentPage() {
      this.loadCases();
      this.updateUrl();
    }
  }
}
</script>

<style lang="scss" scoped>
.jumbotron,
.pagination-container {
  padding-right: 17px !important;
  padding-left: 0 !important;
  >>> .almost-fluid > .row {
    padding: 0 .75rem;
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
.absolute-loader {
  top: 50%;
  transform: transform(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// src/components/cases/CasesSearch.vue